








































































































































































































import { Component, Mixins, Vue } from 'vue-property-decorator'
import * as utils from '@ivy/fts/utils'
import goodsMixin from './goodsMixin'
import * as weixin from '@ivy/fts/weixin'
import orderDetail from './order.vue'
import * as util from './util'
import MicroPage from '@ivy/fts/microPage/index.vue'
import { env } from '@ivy/fts/envInfo/envInfo'
import { addStatistics } from './require'
import { uploadEvent } from '@/statistics'

@Component({
  components: {
    orderDetail,
    MicroPage,
  },
})
export default class ActDetail extends Mixins(goodsMixin) {
  detailCont: any = []
  showMask: boolean = true
  isShowBottomPop: boolean = false
  isShowCenterPop: boolean = false
  popTitle: string = ''
  continuePay: boolean = false
  orderParams: any = {}
  pageId: any = null
  //展示订单详情
  showOrderDetail = false
  needShowBottom = false
  appQueryData = {}
  userinfo
  async mounted() {
    util.addYMPutData()
    utils.cacheSet('goodsPopUrl', window.location.href)
    env.type === 'wx' && (await this.setShare())
    await utils.sleep(500)
    this.userinfo = await env.getInfo()
    try {
      await addStatistics({
        activity_id: this.$route.query.act_id,
        event_type: 'Exposure_PackagingTools',
        p1: this.$route.query.act_id,
        p2: new Date().format('YYYY-MM-DD hh:mm:ss'),
      })
    } catch {}
    await uploadEvent.init()
    uploadEvent.sendPV(
      'Exposure_Page',
      '',
      { PageName: '包装工具', FromPage: 1 },
      [['p1', 'PageName'], ['p2', 'FromPage']]
    )
  }
  //展示当前选择的订单（用于选择实体地址后返回页面）
  showNowChooseOrder() {
    let { sku_id } = this.$route.query
    if (sku_id) {
      let sku = this.skus.filter(s => s.id === +sku_id)
      if (sku) {
        this.showMask = false
        this.onClickBottomItem(sku[0])
      }
    }
  }
  showBottomPop(popTitle) {
    this.popTitle = popTitle
    this.isShowBottomPop = true
    this.addShowContentSta()
  }
  addShowContentSta() {
    try {
      addStatistics({
        activity_id: this.$route.query.act_id,
        event_type: 'Click_PackagingTools_Puw_SelectSku',
        p1: this.spu.id,
        p2: this.$route.query.act_id,
      })
    } catch {}
  }
  //点击首页弹窗
  clickShowmask() {
    this.showMask = false
  }
  async addfirstshowstas() {
    try {
      await addStatistics({
        activity_id: this.$route.query.act_id,
        event_type: 'Click_PackagingTools_Puw_HomePage',
        p1:
          this.skus && this.skus.length === 1
            ? this.skus[0].id
            : this.actConfig.spu_id,
        p2: this.$route.query.act_id,
      })
    } catch {}
    if (this.actConfig.mask_img_link) {
      window.location.href = this.actConfig.mask_img_link
    }
  }
  //关闭内容页
  closeBottomPop() {
    this.isShowBottomPop = false
  }
  //关闭确认订单页
  closeOrderDetails(noShow = false) {
    if (!noShow && this.actConfig.break_pay_mask_status) {
      return this.showCenterPop()
    }
    this.showOrderDetail = false
    //是否需要展示内容页
    if (this.needShowBottom) {
      this.needShowBottom = false
      this.isShowBottomPop = true
    }
  }
  getCanShowAppOrder() {
    if (env.type !== 'ivydad') return false
    let version = this.userinfo.publicParams.version
    if (this.compareAppVersion(version, '5.9.1') >= 0) {
      return true
    }
    return false
  }

  compareAppVersion(v1, v2) {
    if (v1 == null) return -1
    //将两个版本号拆成数组
    let arr1 = v1.split('.'),
      arr2 = v2.split('.')
    let minLength = Math.min(arr1.length, arr2.length) //依次比较版本号每一位大小
    for (let i = 0; i < minLength; i++) {
      if (parseInt(arr1[i]) != parseInt(arr2[i])) {
        return parseInt(arr1[i]) > parseInt(arr2[i]) ? 1 : -1
      }
    }
    //若前几位分隔相同，则按分隔数比较。
    if (arr1.length == arr2.length) {
      return 0
    } else {
      return arr1.length > arr2.length ? 1 : -1
    }
  }

  //打开确认订单页
  async showOrderDetails() {
    this.isShowBottomPop = false
    if (this.getCanShowAppOrder()) {
      await env.init(null, null, null, this.closePop)
      env.showOrderConfirmPopup(this.appQueryData)
    } else {
      this.showOrderDetail = true
    }
  }
  closePop() {
    this.closeOrderDetails()
  }
  showCenterPop() {
    this.isShowCenterPop = true
  }
  //只是关闭弹窗
  closeCenterPop() {
    this.isShowCenterPop = false
    try {
      addStatistics({
        activity_id: this.$route.query.act_id,
        event_type: 'Click_PackagingTools_Puw_order',
        p1: this.skuData.id,
        p2: this.$route.query.act_id,
      })
    } catch {}
    if (this.getCanShowAppOrder()) {
      env.showOrderConfirmPopup(this.appQueryData)
    }
  }
  //关闭弹窗和订单信息页
  closePopUp() {
    this.isShowBottomPop = false
    this.isShowCenterPop = false
    this.showOrderDetail = false
    try {
      addStatistics({
        activity_id: this.$route.query.act_id,
        event_type: 'Click_PackagingTools_Puw_orderButton',
        p1: this.skuData.id,
        p2: this.$route.query.act_id,
      })
    } catch {}
  }

  async selectCourse(e) {
    try {
      addStatistics({
        activity_id: this.$route.query.act_id,
        event_type: 'Click_PackagingTools_BottomButton',
        p1: this.skus.length === 1 ? this.skus[0]['id'] : this.spu.id,
        p2: this.$route.query.act_id,
      })
    } catch {}
    if (this.skus && this.skus.length === 1) {
      return this.onSelect(this.skus[0])
    }
    this.showBottomPop('选择内容')
  }
  onSelect(sku) {
    this.skuData = sku
    // utils.sleep(100)
    this.showOrderDetails()
    this.orderParams = {
      // order页需要的一些参数，为兼容之前路由带参数的方式.
      channelId: this.channelId,
      spuId: this.spu.id,
      actId: this.actId,
      skuId: sku.id,
      type: this.spu.scope,
      discountInfo: this.actConfig.discount_info,
      user_price: sku.salePrice,
    }
    //app支付弹窗的相关参数设置
    this.appQueryData = {
      goods: [
        {
          id: sku.id,
          type: this.spu.scope,
          is_group: 0,
          user_price: sku.salePrice,
        },
      ],
      receiver_id: this.$route.query.receiver_id,
      channel_id: this.channelId,
      pay_scene: 1,
      PageFrom: 'PackagingTools',
    }
  }
  //点击内容item

  onClickBottomItem(sku) {
    //订单返回时需要展示内容列表
    this.needShowBottom = true
    this.onSelect(sku)
  }

  async setShare() {
    if (!this.actConfig) return
    const link = window.location.href
    let options = {
      title: this.actConfig.share_title || '限量招募，常爸好课火热报名中......',
      desc: this.spu.remark,
      imgUrl:
        this.actConfig.share_img ||
        'http://service.ivydad.com/unamed/95d86d6c-6782-60de-58ca-e7b620f45af9.jpg',
      link: encodeURI(link),
    }
    await weixin.weixinShare(options)
  }
}
